import { Box } from '@mui/material';
import { ScrollSeekPlaceholderProps } from 'react-virtuoso';
import { useCatalogView } from '../contexts/CatalogView.context';
import { CatalogViewMode } from '../view/catalogView.types';

export interface CatalogScrollSeekContext {
  maxItemsPerRow: number;
}

const PLACEHOLDER_RADIUS = 1;

const CatalogScrollSeekPlaceholder = ({
  height,
  type,
  context,
}: ScrollSeekPlaceholderProps & { context: CatalogScrollSeekContext }) => {
  const { variant, effectiveMode } = useCatalogView();

  if (type === 'group') {
    return <div style={{ height }} />;
  }

  if (effectiveMode === CatalogViewMode.LIST) {
    return (
      <Box
        sx={{
          height,
          backgroundColor: 'action.hover',
          borderRadius: PLACEHOLDER_RADIUS,
        }}
      />
    );
  }

  const columns = Math.max(1, context.maxItemsPerRow);

  return (
    <Box
      sx={{
        height,
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(0, ${variant.maxWidth}px))`,
        justifyContent: 'center',
        gap: 1.5,
        paddingBottom: 2,
      }}
    >
      {Array.from({ length: columns }, (_unused, column) => (
        <Box
          key={column}
          sx={{ backgroundColor: 'action.hover', borderRadius: PLACEHOLDER_RADIUS }}
        />
      ))}
    </Box>
  );
};

export default CatalogScrollSeekPlaceholder;
